import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { OnDestroyComponent } from '@app/shared/components/on-destroy/on-destroy.component';
import { DialogData, PricingPreference } from '@app/shared/interfaces/lib/dynamic-pricing.interface';
import { EventsService } from '@app/shared/services/events/events.service';
import { PropertiesService } from '@app/shared/services/properties/properties.service';
import { UiModule } from '@app/ui';
import { MaterialModule } from '@app/ui/material.module';

@Component({
  standalone: true,
  selector: 'sbnb-dynamic-pricing-de-activate-modal',
  templateUrl: './dynamic-pricing-de-activate-modal.component.html',
  styleUrls: ['./dynamic-pricing-de-activate-modal.component.scss'],
  imports: [CommonModule, UiModule, MaterialModule],
})
export class DynamicPricingDeActivateModalComponent extends OnDestroyComponent implements OnInit {
  private dynamicPricingData: any = {};
  public loading = false;

  constructor(
    public dialogRef: MatDialogRef<DynamicPricingDeActivateModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: DialogData,
    private propertiesService: PropertiesService,
    private eventsService: EventsService
  ) {
    super();
  }

  public ngOnInit() {
    const { property, dynamic_pricing_enabled, base_price_type, min_price, max_price } = this.dialogData;
    this.dynamicPricingData = { property, dynamic_pricing_enabled, base_price_type, min_price, max_price };
  }

  public closeModal() {
    this.dialogRef.close();
  }

  public turnOffDynamicPricing() {
    const payload = {
      dynamic_pricing_enabled: false,
      outbound_dynamic_pricing_enabled: false,
      base_price_type: PricingPreference.RECOMMENDED,
    };
    this.loading = true;
    this.propertiesService.setDynamicPricingOptions(this.dynamicPricingData.property.id, payload).subscribe((data) => {
      this.eventsService.fire(`dynamic-pricing-disabled-${this.dynamicPricingData.property.id}`, true);
      setTimeout(() => {
        this.loading = false;
        this.closeModal();
      }, 1000);
    });
  }
}
